import React from "react";

import SpaceNeedleSVG from "./../../images/noun_68012-spaceneedle.svg";
import WaterfrontSVG from "./../../images/noun_755386-waterfront.svg";
import BoatSVG from "./../../images/noun_1360677-boat.svg";
import SphereSVG from "./../../images/noun_945817-sphere.svg"; 

const Features = () => (
  <div className="bg-brand-blue py-16 ">
    <div className="w-5/6 max-w-xl mx-auto" data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
      <h3 className="text-center text-brand-white w-3/4 py-2 mx-auto leading-normal font-bold font-title text-xl py-6">Our tours feature local attractions:
      </h3>
      <div className="flex flex-row flex-wrap items-center justify-around text-center max-w-xl mx-auto p-4 md:p-8 text-sm">
        <div className="p-4">
          <img className="fill-current text-blue h-24" src={SpaceNeedleSVG} alt="An icon for The Space Needle"></img>
          <p className="text-brand-white text-lg text-center mt-2">
            Space Needle
          </p>
        </div>

        <div className="p-4">
          <img className="fill-current text-blue h-24 " src={SphereSVG} alt="An icon representing The Amazon Spheres at HQ1"></img>
          <p className="text-brand-white text-lg text-center mt-2">
            Amazon Spheres
          </p>
        </div>

        <div className="p-4">
          <img className="fill-current text-blue h-24" src={BoatSVG} alt="A Boat icon to represent the Ballard Locks"></img>
          <p className="text-brand-white text-lg text-center mt-2">
            Ballard Locks
          </p>
        </div>

        <div className="p-4">
          <img className="fill-current text-blue h-24" src={WaterfrontSVG} alt="An icon representing the Seattle Waterfront"></img>
          <p className="text-brand-white text-lg text-center mt-2">
            Seattle Waterfront
          </p>
        </div>

      </div>
    </div>
  </div>
);

export default Features;



// WEBPACK FOOTER //
// ./src/components/Features/index.js